import axios from "axios";

export default class Service {
    constructor() {
        this.url = "/api/Settings/";
    }

    getUserSettings() {
        return axios.get(this.url + "GetUserSettings");
    }

    setUserSettings(request) {
        return axios.post(this.url + "SetUserSettings", request);
    }

    getClientSettings() {
        return axios.get(this.url + "GetClientSettings");
    }

    setClientSettings(request) {
        return axios.post(this.url + "SetClientSettings", request);
    }
}